import React from 'react'

const Loader = () => {
    return (
        <>
            <div className="con"><svg><circle cx="70" cy="70" r="20"></circle></svg></div>
        </>
    )
}

export default Loader
